<template>
  <container-sc>
    <div class="header">
      <img src="/textures/page/icon/back_black.svg" @click="onBackClick"/>
      <span>{{title}}</span>
    </div>
    <div class="content">
      <div class="search-box">
        <img class="search-icon" src="/textures/page/icon/search.svg"/>
        <input v-model="searchStr" :placeholder="placeholder"/>
        <img
          class="clear-icon"
          src="/textures/page/icon/clear.svg"
          @click="handleClearClick"
          v-show="searchStr"
        />
      </div>
      <div class="search-list">
        <div class="no-person" v-if="list.length === 0">
          <img src="/textures/page/icon/no_record.svg"/>
          <span class="title">{{noRecordTitle}}</span>
          <span class="sub-title">{{noRecordSubTitle}}</span>
        </div>
        <div
          class="no-result"
          v-else-if="listShow.length === 0"
        >{{$t('liveDeco.blankSearchResult')}}</div>
        <div class="list" v-else>
          <div :class="['item', {active: item.isSelected}]" v-for="item in listShow" :key="item.id" @click="handleItemClick(item)">
            <img :src="item.wxAvatarUrl"/>
            <span class="title" :innerHTML="item.renderName"></span>
          </div>
        </div>
      </div>
    </div>
  </container-sc>
</template>

<script setup>
import {ContainerSc} from './selectPersonSc';
import {ref, computed, reactive} from 'vue';

const props = defineProps({
  list: Array,
  noRecordTitle: String,
  noRecordSubTitle: String,
  onBackClick: Function,
  onItemCanceled: Function,
  onItemSelected: Function,
  placeholder: String,
  selectedItem: {
    type: Object,
    default: () => {}
  },
  title: String
});

const searchStr = ref('');
const selected = reactive({...props.selectedItem, isSelected: true});
const renderSearchTitle = (personName) => {
  if (personName) {
    if (!searchStr.value) {
      return personName;
    }
    return personName.replaceAll(
      searchStr.value,
      `<span class="keyword">${searchStr.value}</span>`
    );
  }
};
const listShow = computed(() => {
  const list = [];
  props.list.forEach(item => {
    if (searchStr.value && !item.staffName.includes(searchStr.value)) {
      return;
    }
    const newItem = {...item};
    newItem.renderName = renderSearchTitle(item.staffName);    
    if (item.id === selected.id) {
      newItem.isSelected = selected.isSelected;
      list.splice(0, 0, newItem);
    } else {
      list.push(newItem);
    }
  });
  return list;
});
const handleClearClick = () => {
  searchStr.value = '';
};
const handleItemClick = (item) => {
  if (item.isSelected) {
    item.isSelected = false;
    if (item.id === selected.id) {
      selected.isSelected = false;
    }
    props.onItemCanceled();
    return;
  }
  item.renderName = item.staffName;
  props.onItemSelected(item);
};
</script>